import { Reveal } from "./Reveal";

export const Compounding = () => (
  <section id="compounding" className="relative py-12 md:py-20 border-t border-white/[0.05]" data-testid="compounding-section">
    <div className="mx-auto max-w-[1240px] px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <p className="text-sm font-medium tracking-widest uppercase text-teal mb-5">Compounding value</p>
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-50 leading-[1.08]">
            Value compounds over time
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-400">
            SalesMoat does not deliver full value on day one. It delivers accelerating value as the
            per-rep IP database compounds. Meaningful differentiation typically emerges between
            <span className="text-slate-200"> months 6–12</span>.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-7">
          <div className="relative rounded-3xl border border-white/[0.08] bg-gradient-to-b from-white/[0.04] to-transparent p-3 shadow-[0_20px_60px_rgba(0,0,0,0.35)]">
            <img
              src="/assets/compounding.jpg"
              alt="SalesMoat value timeline showing compounding IP advantage over months"
              className="w-full rounded-2xl"
              data-testid="compounding-image"
            />
          </div>
          <p className="mt-5 text-center text-sm text-slate-500 italic">
            Value is front-loaded in capture, back-loaded in intelligence.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
